import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconFileId = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M31 15V35C31 37.2091 29.2091 39 27 39H5C2.79086 39 1 37.2091 1 35V5C1 2.79086 2.79086 1 5 1H17",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 15V1L31 15H17Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.76 26.4792H6V34.2392H7.76V26.4792Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0014 26.4792H9.44141V34.2392H11.9214C14.6414 34.2392 16.0014 32.7192 16.0014 30.3992V30.3193C16.0814 27.9193 14.7214 26.4792 12.0014 26.4792ZM14.2414 30.3992C14.2414 31.9992 13.5214 32.8792 11.9214 32.8792H11.2014V27.8392H11.9214C13.5214 27.8392 14.2414 28.7193 14.2414 30.3193V30.3992Z",
  fill: "black"
}));
export { IconFileId };